import { getDateFormatted } from '@shared/utils'
import { useTranslation } from 'react-i18next'
import {
  SRBigCalendarEventDayBlockStyle,
  SRBigCalendarEventDayStyle,
} from './styles'
import { SRBigCalendarEvent } from '../../../sr-big-calendar'

export const SRBigCalendarEventDay = ({
  event,
}: {
  event: SRBigCalendarEvent
}) => {
  const { t } = useTranslation()

  if (!event) return

  const { start, end, isTravelTime, appointmentType, policy } = event as any

  const startDate = getDateFormatted(start, 'HH:mm')
  const endDate = getDateFormatted(end, 'HH:mm')

  if (isTravelTime) {
    return (
      <SRBigCalendarEventDayStyle>
        <SRBigCalendarEventDayBlockStyle>
          <div className="text-center">
            <span>{startDate}</span>
            <span> - </span>
            <span>{endDate}</span>
          </div>
        </SRBigCalendarEventDayBlockStyle>
      </SRBigCalendarEventDayStyle>
    )
  }

  return (
    <SRBigCalendarEventDayStyle>
      <SRBigCalendarEventDayBlockStyle>
        <div className="text-center">
          <span>{startDate}</span>
          <span> - </span>
          <span>{endDate}</span>
        </div>
      </SRBigCalendarEventDayBlockStyle>
      <SRBigCalendarEventDayBlockStyle>
        {appointmentType && <div>{t(appointmentType.text)}</div>}
        {policy && (
          <>
            <div>-</div>
            <div className="underline">{policy.fullName}</div>
          </>
        )}
      </SRBigCalendarEventDayBlockStyle>
    </SRBigCalendarEventDayStyle>
  )
}
